<template>
  <v-container>
    <p class="primary--text text-center display-1">{{$t('DeviceTypes.DeviceType-Info')}}</p>
    <v-container>
      <v-row>
        <v-col cols="12" sm="12">
          <v-text-field
            v-model="choosenDeviceType.deviceTypeId"
            :readonly="readonly"
            :label="$t('DeviceTypes.id')"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12">
          <v-text-field
            v-model="name"
            :readonly="readonly"
            :label="$t('DeviceTypes.name')"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12">
          <v-textarea :readonly="readonly" v-model="description" auto-grow rows="1">
            <template v-slot:label>
              <div>{{$t('DeviceTypes.description')}}</div>
            </template>
          </v-textarea>
        </v-col>
      </v-row>
      <editbuttons
        @back="$emit('back')"
        :admin="admin"
        @user="$emit('user')"
        @delete="deleteDeviceType"
        @edit="$emit('edit')"
      ></editbuttons>
      <v-row>
        <v-col class="text-center">
          <v-btn class="ma-2" tile outlined color="primary" @click="$emit('dataAndAlert')">
            <v-icon left>mdi-alert</v-icon>
            {{$t('DeviceTypes.manageDataAndAlert')}}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <br />
    <p class="primary--text text-center display-1">{{$t('DeviceTypes.DeviceType-Map')}}</p>
    <map-comp
      :markerLatLng="markers"
      :toCenterLatLong="markers[0]"
      :tooltips="tooltips"
      :mapheight="'500px'"
      :mapwitdh="'100%'"
      :countDevice="countDevice"
      @clickmarker="clickmarker"
    ></map-comp>
    <br />
    <p class="primary--text text-center display-1">{{$t('DeviceTypes.DeviceType-Properties')}}</p>
    <v-container>
      <v-alert
        :type="alertType"
        transition="scale-transition"
        v-model="alert"
        border="left"
        dismissible
      >{{alertMsg}}</v-alert>
      <v-card class="mt-5">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">{{$t('DeviceTypes.property')}}</th>
                <th class="text-left">{{$t('DeviceTypes.type')}}</th>
                <th class="text-left">{{$t('DeviceTypes.description')}}</th>
                <th>
                  <property-dialog
                    :prop="{}"
                    :deviceTypeId="deviceTypeId"
                    :add="true"
                    :update="false"
                    @propertyadded="propertyAdded"
                  ></property-dialog>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(prop,index) in properties" :key="index">
                <td>{{ prop.property }}</td>
                <td>{{ prop.type }}</td>
                <td>{{ prop.description }}</td>
                <td>
                  <property-dialog
                    :prop="prop"
                    :deviceTypeId="deviceTypeId"
                    :add="false"
                    :update="true"
                    @propertydeleted="propertyDeleted"
                    @propertyupdated="propertyUpdated"
                  ></property-dialog>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-container>
    <br />
    <p class="primary--text text-center display-1">{{$t('DeviceTypes.DeviceType-MQTTConnection')}}</p>
    <v-container>
      <v-card class="mt-5">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">{{$t('DeviceTypes.hostname')}}</th>
                <th class="text-left">{{$t('DeviceTypes.port')}}</th>
                <th class="text-left">{{$t('DeviceTypes.topic')}}</th>
                <th class="text-left">{{$t('DeviceTypes.username')}}</th>
                <th class="text-left">{{$t('DeviceTypes.state')}}</th>
                <th>
                  <v-btn icon @click="$emit('addMqtt')">
                    <v-icon>add</v-icon>
                  </v-btn>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(mqtt,index) in mqtts" :key="index">
                <td>{{ mqtt.url }}</td>
                <td>{{ mqtt.port }}</td>
                <td>{{ mqtt.topic }}</td>
                <td>{{ mqtt.username }}</td>
                <td>
                  <v-icon class="ma-1" :color="mqtt.iconColor">{{mqtt.icon}}</v-icon>
                  {{ mqtt.state }}
                </td>
                <td>
                  <v-btn icon @click="$emit('updateMqtt',mqtt)">
                    <v-icon>settings</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-container>
  </v-container>
</template>

<script>
import EditButtonsComponent from "./EditButtons";
import PropertyDialogComponent from "./PropertyDialog";
import MapComponent from "../Map/Map";

import axios from "axios";
import tokenStore from "../../store/TokenStore";

export default {
  components: {
    editbuttons: EditButtonsComponent,
    "property-dialog": PropertyDialogComponent,
    "map-comp": MapComponent,
  },
  data() {
    return {
      readonly: true,
      alert: false,
      alertMsg: "",
      alertType: "error",
      markers: [],
      tooltips: [],
      countDevice: 0,
      mqtts: [],
    };
  },
  computed: {
    name: function () {
      return this.choosenDeviceType.name;
    },
    description: function () {
      return this.choosenDeviceType.description;
    },
    deviceTypeId: function () {
      return this.choosenDeviceType.deviceTypeId;
    },
    properties: {
      get: function () {
        return this.choosenDeviceType.properties;
      },
      set: function (value) {
        this.choosenDeviceType.properties = value;
      },
    },
    scopes: function () {
      return this.choosenDeviceType.scopes;
    },
    admin: function () {
      let index = this.scopes.findIndex((scope) => {
        return scope == "admin" || scope == "creator";
      });
      return index >= 0;
    },
  },
  props: {
    choosenDeviceType: Object,
  },
  methods: {
    deleteDeviceType: function () {
      axios
        .delete(
          process.env.VUE_APP_API_ADDR + "/api/devicetype/" + this.deviceTypeId,
          {
            headers: { Authorization: tokenStore.getToken() },
          }
        )
        .then((res) => {
          if (res.data.success) {
            this.$emit("saved", this.$t("DeviceTypes.Alert.success-remove"));
          }
        })
        .catch((err) => {
          this.$emit("error", err.response.data.errorMessage);
        });
    },
    propertyAdded: function () {
      this.alertType = "success";
      this.alertMsg = this.$t("DeviceTypes.Alert.success-add-property");
      this.alert = true;
      this.reloadProperty();
    },
    propertyUpdated: function () {
      this.alertType = "success";
      this.alertMsg = this.$t("DeviceTypes.Alert.success-update-property");
      this.alert = true;
      this.reloadProperty();
    },
    propertyDeleted: function () {
      this.alertType = "success";
      this.alertMsg = this.$t("DeviceTypes.Alert.success-remove-property");
      this.alert = true;
      this.reloadProperty();
    },
    reloadProperty: function () {
      axios
        .get(
          process.env.VUE_APP_API_ADDR +
            "/api/deviceType/" +
            this.deviceTypeId +
            "/property",
          {
            headers: { Authorization: tokenStore.getToken() },
          }
        )
        .then((res) => {
          if (res.data.success) {
            this.properties = res.data.deviceType.properties;
          }
        })
        .catch(() => {
          this.alertType = "error";
          this.alertMsg = this.$t("DeviceTypes.Alert.error");
          this.alert = true;
        });
    },
    clickmarker: function (value) {
      this.$emit("clickmarker", value);
    },
  },
  beforeMount: function () {
    axios
      .get(process.env.VUE_APP_API_ADDR + "/api/user/@me", {
        headers: { Authorization: tokenStore.getToken() },
      })
      .then((res) => {
        let $networks = res.data.user.permissions.networks;
        axios
          .get(
            process.env.VUE_APP_API_ADDR +
              "/api/deviceType/" +
              this.deviceTypeId +
              "/mqtt",
            {
              headers: { Authorization: tokenStore.getToken() },
            }
          )
          .then((res) => {
            if (res.data.success) {
              this.mqtts = res.data.deviceType.mqtts;
              this.mqtts.forEach((mqtt) => {
                if (mqtt.state.startsWith("working")) {
                  mqtt.icon = "mdi-check-circle";
                  mqtt.iconColor = "success";
                } else if (mqtt.state == "waiting data") {
                  mqtt.icon = "mdi-help-circle";
                  mqtt.iconColor = "info";
                } else {
                  mqtt.icon = "mdi-alert-circle";
                  mqtt.iconColor = "error";
                }
              });
            }
          })
          .catch(() => {
            this.alertType = "error";
            this.alertMsg = this.$t("DeviceTypes.Alert.error");
            this.alert = true;
          });
        axios
          .get(
            process.env.VUE_APP_API_ADDR +
              "/api/deviceType/" +
              this.deviceTypeId +
              "/devices",
            {
              headers: { Authorization: tokenStore.getToken() },
            }
          )
          .then((res) => {
            if (res.data.success) {
              res.data.devices.forEach((device) => {
                let index = $networks.findIndex((network) => {
                  return network.networkId == device.networkId;
                });
                if (index >= 0) {
                  axios
                    .get(
                      process.env.VUE_APP_API_ADDR +
                        "/api/device/" +
                        device.id +
                        "/deviceTypeProperty",
                      {
                        headers: { Authorization: tokenStore.getToken() },
                      }
                    )
                    .then((res) => {
                      if (res.data.success) {
                        let lat = Number(
                          res.data.device.deviceTypeProperty[
                            res.data.device.deviceTypeProperty.findIndex(
                              (prop) => prop.property == "lat"
                            )
                          ].value
                        );
                        let long = Number(
                          res.data.device.deviceTypeProperty[
                            res.data.device.deviceTypeProperty.findIndex(
                              (prop) => prop.property == "long"
                            )
                          ].value
                        );

                        this.markers.push([lat, long]);
                        this.countDevice += 1;
                        device.lat = lat;
                        device.long = long;
                        this.tooltips.push(device);
                      }
                    })
                    .catch(() => {
                      this.alertType = "error";
                      this.alertMsg = this.$t("DeviceTypes.Alert.error");
                      this.alert = true;
                    });
                }
              });
            }
          })
          .catch(() => {
            this.alertType = "error";
            this.alertMsg = this.$t("DeviceTypes.Alert.error");
            this.alert = true;
          });
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>
